const SvgDoors = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 40 40">
    <path fill="#373737" d="M28.822 7.815v24.407H11.197V7.814zM30 6.667H10v26.666h20z" />
    <path fill="#373737" d="M25.52 11.119V28.88H14.48V11.12zM26.665 10H13.333v20h13.333z" />
    <path fill="#373737" d="M22.778 21.111a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333" />
  </svg>;
export default SvgDoors;